import React from 'react';
// @ts-ignore: next-line
import { shsLogo } from '@images';
import { Link } from 'gatsby';

const LogosContainer: React.FC = () => {
  return (
    <div className="logo-container">
      <Link to="/">
        <img src={shsLogo} alt="SHS Logo" className="shs-logo" />
        <div className="empowerme-logo">EmpowerMe</div>
      </Link>
    </div>
  );
};

export default LogosContainer;
